import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { TabList, Tab, mergeClasses } from '@fluentui/react-components';
import { AddSquareRegular, AddSquareFilled, HeadphonesSoundWaveRegular, HeadphonesSoundWaveFilled, DesignIdeasRegular, DesignIdeasFilled } from '@fluentui/react-icons';

import { useStyles } from './style';

const AssetsId = 'edit-video-assets-view';
const StyleId = 'edit-video-style-view';
const AudioId = 'edit-video-audio-view';

export const EditVideoNavigationView = ({
  i18n,
  currentView,
  setCurrentView,
}) => {
  const classes = useStyles();

  const selectItem = useCallback((id) => {
    setCurrentView(id);
  }, [setCurrentView]);

  const isSelected = useCallback(id => currentView === id, [currentView]);

  const items = useMemo(() => ([
    {
      id: AssetsId,
      name: _TL_('Assets'),
      onClick: () => selectItem(AssetsId),
      icon: () => (isSelected(AssetsId) ? <AddSquareFilled /> : <AddSquareRegular />),
      isSelected: currentView === AssetsId,
    },
    {
      id: StyleId,
      name: _TL_('Style'),
      onClick: () => selectItem(StyleId),
      icon: () => (isSelected(StyleId) ? <DesignIdeasFilled /> : <DesignIdeasRegular />),
      isSelected: currentView === StyleId,
    },
    {
      id: AudioId,
      name: _TL_('Audio'),
      onClick: () => selectItem(AudioId),
      icon: () => (isSelected(AudioId) ? <HeadphonesSoundWaveFilled /> : <HeadphonesSoundWaveRegular />),
      isSelected: currentView === AudioId,
    },
  ]), [currentView, isSelected, selectItem]);

  const tabItem = useCallback(item => (
    <Tab
      key={item.id}
      value={item.id}
      icon={item.icon()}
      onClick={item.onClick}
      selected={item.isSelected}
      className={mergeClasses(item.id, classes.tabItem)}
    >
      {i18n.getString(item.name)}
    </Tab>
  ), [i18n]);

  return (
    <div className={mergeClasses(classes.editVideoPageNavigation, 'video-edit-page-navigation')}>
      <TabList vertical selectedValue={currentView} className={classes.tabList}>
        {items.map(item => (
          <div key={item.id}>
            <div className={mergeClasses('tab-item', classes.tabItemWrapper, item.isSelected && 'selected')}>
              {tabItem(item)}
            </div>
          </div>
        ))}
      </TabList>
    </div>
  );
};

EditVideoNavigationView.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  currentView: PropTypes.string,
  setCurrentView: PropTypes.func.isRequired,
};

EditVideoNavigationView.defaultProps = {
  currentView: AssetsId,
};
